module.exports = __webpack_public_path__ + "img/register-v2.6d411d54.svg";